import React, { useState } from 'react';
import { desktopscreensize } from '../../../../utilities/constants';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { weakKey } from '../../../../utilities/weakKey';
import { FacilityHrs } from '../locationMap/components/FacilityHrs';
import { getFormattedHrs } from '../locationMap/LocationMap';
import { LocationTypes } from '../locationMap/locationTypes';
import { FooterTypes } from './footerTypes';
import { getTextColor } from './helpers/ColorSelectorHelper';
import { useThemeContext } from './hooks/themeContext';

export const FooterOfficeAndGateHours = ({
  show,
  curlocations,
  isHoursForAllLocationsSame,
  locationType,
}: FooterTypes.IFacilityHrs) => {
  const { width } = useWindowDimensions();
  const currTheme = useThemeContext();
  const [showFacilityHrs, setShowFacilityHrs] = useState(show);
  const showFacilityHoursOverTabletResolution = true;

  const onFacilityHrsToggle = () => {
    setShowFacilityHrs(!showFacilityHrs);
  };

  const showFacilityAndGateHours = (width: number) => {
    return width < desktopscreensize
      ? showFacilityHrs
      : showFacilityHoursOverTabletResolution;
  };
  const renderFacilityHours = (
    formattedHrs: LocationTypes.TFormattedFacilityHours,
    location: LocationTypes.TLocation
  ) => {
    return (
      <div
        className={`has-text-${getTextColor(currTheme)}`}
        key={weakKey(location)}
      >
        <FacilityHrs
          show={showFacilityAndGateHours(width)}
          onFacilityHrsToggle={onFacilityHrsToggle}
          formattedHrs={formattedHrs}
          theme={currTheme}
        />
      </div>
    );
  };
  const getFaciltyHoursForSingleLocation = () => {
    const formattedHrs = getFormattedHrs(curlocations[0]);
    return renderFacilityHours(formattedHrs, curlocations[0]);
  };

  const getFaciltyHoursForMultiLocation = () => {
    return (
      <>
        {isHoursForAllLocationsSame &&
          curlocations.slice(0, 1).map((location) => {
            const formattedHrs = getFormattedHrs(location);
            return renderFacilityHours(formattedHrs, location);
          })}
      </>
    );
  };

  const getFacilityHours = (locationType: FooterTypes.TLocationType) => {
    switch (locationType) {
      case 'multi':
        return getFaciltyHoursForMultiLocation();
      default:
        return getFaciltyHoursForSingleLocation();
    }
  };
  return <>{getFacilityHours(locationType)}</>;
};
